import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const FoundersDayCelebrations2025 = () => {
    const workshopImages = [
        "Founders-day-2025-1.jpeg",
        "Founders-day-2025-2.jpeg",
        "Founders-day-2025-3.jpeg",
    ];
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>Honoring a Legacy on Founders' Day    </h2>
                                    <div className='py-2'>
                                        <p>

                                            This Founders' Day was marked by a solemn ceremony to honor our late Chairman, Shri K Ashok Rao Sir. Vice Chairman Dr. K Radhakishan Rao Sir led the commemoration, garlanding the founder's statue and addressing the college's key stakeholders. He reaffirmed the college's commitment to diligently pursue and expand upon Shri K Ashok Rao Sir's groundbreaking vision and legacy.

                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">

                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Founders-Day-Celebrations-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Founders-Day-Celebrations-2025/${img}`}
                                                            alt={`Founders Day Celebrations 2025 Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default FoundersDayCelebrations2025;
